import React from 'react';

import { createStylesHook } from 'shared';

interface PanelInfoProps {
  backgroundColor: string;
  text: string;
}

const useStyles = createStylesHook({
  containerPanel: {
    padding: '16px 16px',
    width: '100%'
  }
});

export const PanelInfo: React.FunctionComponent<PanelInfoProps> = ({ backgroundColor, text }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <div className={classes.containerPanel} style={{ backgroundColor }}>
      {text}
    </div>
  );
};
